@if (menuParams && payment && chat2PayResult) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="payment">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <input class="control-input" activeForm [activeForm]="payment" id="name" [formControlName]="'name'" placeholder="Enter a name"/>
            <input-validators controlName="name" [control]="payment.controls['name']"></input-validators>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Select Extension </label>
            </div>
            <mat-select class="dynamic-dropdown"
              [formControlName]="'extension'"
              placeholder="Select Extension"
              (selectionChange)="onExtensionChange($event)">
              @for (option of extensions; track option) {
                <mat-option [value]="option.id">
                  {{ option.name }}
                </mat-option>
              }
            </mat-select>
            <input-validators controlName="extension" [control]="payment.controls['extension']"></input-validators>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Message for Link </label>
            </div>
            <textarea class="control-input control-area"
              id="messageForLink"
              activeForm
              [activeForm]="payment"
              [formControlName]="'messageForLink'"
              [placeholder]="'Enter a message for the end-user to see before the Chat 2 Pay link.'">
            </textarea>
            <input-validators controlName="messageForLink" [control]="payment.controls['messageForLink']"></input-validators>
          </div>
          <div class="control-div ">
            <div class="control-label-container">
              <label class="control-label"> Currency </label>
            </div>
            <div class="currency-block">
              <mat-button-toggle-group (change)="currencyChanged($event)"
                #group="matButtonToggleGroup" [value]="group.value" multiple="false"
                [formControlName]="'currency'"
                hideSingleSelectionIndicator>
                <mat-button-toggle class="selector-button" [value]="'variable'">Variable</mat-button-toggle>
                <mat-button-toggle class="selector-button" [value]="'predefined'">Predefined</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          @if (payment.value.currency === 'predefined') {
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Amount Incl. Tax </label>
              </div>
              <div class="money-types-autocomplete-block">
                <div class="money-types-autocomplete-input-block">
                  <div class="selected-money-symbol">{{ selectedMoneyType?.symbol }}</div>
                  <input class="control-input"
                    id="amount"
                    activeForm
                    [activeForm]="payment"
                    [formControlName]="'amount'"
                    placeholder="Enter amount"/>
                    <div class="selected-money-type" [ngClass]="{active: activeSearchMoneyTypes}" (click)="setActiveSearchMoneyTypes()">{{ selectedMoneyType?.iso }}</div>
                  </div>
                  @if (activeSearchMoneyTypes) {
                    <div class="money-types-autocomplete-search-block"
                      matAutocompleteOrigin
                      #origin="matAutocompleteOrigin">
                      <div class="close" (click)="clearSearchForm()"></div>
                      <form>
                        <input class="search"
                          type="text"
                          #searchMoneyType
                          placeholder="Search country or symbol"
                          [matAutocomplete]="auto"
                          [formControl]="searchControl"
                          (ngModelChange)="filterMoneyTypes($event)"
                          (blur)="blurSearchMoneyType()"
                          [matAutocompleteConnectedTo]="origin">
                          <mat-autocomplete class="chat2pay-autocomplete" autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setActiveMoneyType($event.option.value)">
                            @for (option of filteredOptions; track option) {
                              <mat-option  class="chat2pay-autocomplete-option" [value]="option.name">
                                {{option.name}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </form>
                      </div>
                    }
                  </div>
                  <div class="amount-Incl-Tax-container">
                    <input-validators   controlName="amount" [control]="payment.controls['amount']"></input-validators>
                  </div>
                </div>
              } @else {
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Currency Variable </label>
                  </div>
                  <input class="control-input"
                    id="currencyCode"
                    activeForm
                    [activeForm]="payment"
                    [formControlName]="'currencyCode'"
                    placeholder="Enter variable"/>
                    <input-validators controlName="currencyCode" [control]="payment.controls['currencyCode']"></input-validators>
                  </div>
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> Amount </label>
                    </div>
                    <input class="control-input"
                      name="amount"
                      activeForm
                      [activeForm]="payment"
                      [formControlName]="'amount'"
                      placeholder="Enter amount"/>
                      <input-validators controlName="amount" [control]="payment.controls['amount']"></input-validators>
                    </div>
                  }
                  <div class="control-div">
                    <div class="control-label-container">
                      <label class="control-label"> Tax % </label>
                      <label class="control-optional">Optional</label>
                    </div>
                    <div class="input-symbol-block">
                      <input class="control-input symbol"
                        id="tax"
                        activeForm
                        [activeForm]="payment"
                        [formControlName]="'tax'"
                        placeholder="Enter percent amount"/>
                        <div class="symbol-icon">%</div>
                      </div>
                    </div>
                    <ng-container [formGroup]="menuParams">
                      <div class="control-div toggle-field">
                        <div class="label-left-block">
                          <label class="control-label"> Generate Order No. </label>
                          <app-cms class="popover" [type]="'nodeBuild'" [field]="'generateOrderNo'"></app-cms>
                        </div>
                        <div class="toggle-btn">
                          <mat-slide-toggle
                            [color]="'primary'"
                            class="control-toggle"
                            [formControlName]="'generateOrderNumber'"
                            (change)="toggleGenerateOrderNumber($event)">
                          </mat-slide-toggle>
                        </div>
                      </div>
                      @if (!menuParams.value.generateOrderNumber) {
                        <div class="control-div">
                          <div class="control-label-container">
                            <label class="control-label"> Order Number </label>
                          </div>
                          <input class="control-input symbol"
                            id="orderNumber"
                            activeForm
                            [activeForm]="menuParams"
                            [formControlName]="'orderNumber'"
                            placeholder="Enter order number"/>
                            <input-validators controlName="orderNumber" [control]="menuParams.controls['orderNumber']"></input-validators>
                          </div>
                        }
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </clickatell-expansion-panel>
                <clickatell-expansion-panel>
                  <ng-container header>
                    <mat-panel-title>
                      Additional Data
                    </mat-panel-title>
                  </ng-container>
                  <ng-container body>
                    <ng-container [formGroup]="menuParams">
                      @for (item of additionalData.controls; track item; let i = $index) {
                        <div class="additionaldata-item">
                          <div [formGroup]="item" class="additionaldata-item-block">
                            <div class="control-div">
                              <input class="control-input" [formControlName]="'key'" placeholder="Key"/>
                              <input-validators controlName="key" [control]="item.controls['key']"></input-validators>
                            </div>
                            <div class="control-div">
                              <input class="control-input" [formControlName]="'value'" placeholder="Value"/>
                              <input-validators controlName="value" [control]="item.controls['value']"></input-validators>
                            </div>
                            <div class="btn-block">
                              <button class="delete-additionaldata-item-btn" [disabled]="!canEdit" (click)="removeAdditionalDataItem(i)">
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                      <button class="add-additionaldata-button" (click)="addAdditionalData()" [disabled]="!canEdit">
                        Add New
                      </button>
                    </ng-container>
                  </ng-container>
                </clickatell-expansion-panel>
                <clickatell-expansion-panel>
                  <ng-container header>
                    <mat-panel-title>
                      Logic
                    </mat-panel-title>
                  </ng-container>
                  <ng-container body>
                    <div class="logic-item-block">
                      <div class="control-div" [formGroup]="PAYMENT_COMPLETED">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                        <input class="control-input" [formControlName]="'key'" [attr.disabled]="true"/>
                      </div>
                      <div class="control-div" [formGroup]="PAYMENT_COMPLETED">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <input class="control-input" [formControlName]="'description'"/>
                      </div>
                      <div class="control-div" [formGroup]="payment">
                        <div class="control-label-container">
                          <label class="control-label"> Confirmation Message </label>
                        </div>
                        <textarea class="control-input control-area"
                          id="confirmationMessage"
                          activeForm
                          [activeForm]="payment"
                          [formControlName]="'confirmationMessage'"
                          [placeholder]="'Preheader text...'">
                        </textarea>
                        <input-validators controlName="messageForLink" [control]="payment.controls['confirmationMessage']"></input-validators>
                      </div>
                      <div class="control-div">
                        <ng-container *ngTemplateOutlet="next; context: { controlName: 'next', form: results.controls['PAYMENT_COMPLETED']}">
                        </ng-container>
                      </div>
                    </div>
                    <div class="logic-item-block">
                      <div class="control-div" [formGroup]="PAYMENT_DECLINED">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                        <input class="control-input" [formControlName]="'key'" [attr.disabled]="true"/>
                      </div>
                      <div class="control-div" [formGroup]="PAYMENT_DECLINED">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <input class="control-input" [formControlName]="'description'"/>
                      </div>
                      <div class="control-div">
                        <ng-container *ngTemplateOutlet="next; context: { controlName: 'next', form: results.controls['PAYMENT_DECLINED']}">
                        </ng-container>
                      </div>
                    </div>
                    <div class="logic-item-block">
                      <div class="control-div" [formGroup]="PAYMENT_UNKNOWN">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                        <input class="control-input" [formControlName]="'key'" [attr.disabled]="true"/>
                      </div>
                      <div class="control-div" [formGroup]="PAYMENT_UNKNOWN">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <input class="control-input" [formControlName]="'description'"/>
                      </div>
                      <div class="control-div">
                        <ng-container *ngTemplateOutlet="next; context: { controlName: 'next', form: results.controls['PAYMENT_UNKNOWN']}">
                        </ng-container>
                      </div>
                    </div>
                    <div class="logic-item-block">
                      <div class="control-div" [formGroup]="PAYMENT_REVIEW">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                        <input class="control-input" [formControlName]="'key'" [attr.disabled]="true"/>
                      </div>
                      <div class="control-div" [formGroup]="PAYMENT_REVIEW">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <input class="control-input" [formControlName]="'description'"/>
                      </div>
                      <div class="control-div toggle-field" [formGroup]="payment">
                        <div class="label-left-block">
                          <label class="control-label"> Auto Reverse Payment </label>
                        </div>
                        <div class="toggle-btn">
                          <mat-slide-toggle [color]="'primary'" class="control-toggle" [formControlName]="'autoReversePayment'">
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <div class="control-div">
                        <ng-container *ngTemplateOutlet="next; context: { controlName: 'next', form: results.controls['PAYMENT_REVIEW']}">
                        </ng-container>
                      </div>
                    </div>
                    <div class="logic-item-block">
                      <div class="control-div" [formGroup]="TIMEOUT">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                        <input class="control-input" [formControlName]="'key'" [attr.disabled]="true"/>
                      </div>
                      <div class="control-div" [formGroup]="TIMEOUT">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <input class="control-input" [formControlName]="'description'"/>
                      </div>
                      <div class="control-div">
                        <ng-container *ngTemplateOutlet="next; context: { controlName: 'next', form: results.controls['TIMEOUT']}">
                        </ng-container>
                      </div>
                    </div>
                    <div class="logic-item-block">
                      <div class="control-div" [formGroup]="ERROR">
                        <div class="control-label-container">
                          <label class="control-label"> Result </label>
                        </div>
                        <input class="control-input" [formControlName]="'key'" [attr.disabled]="true"/>
                      </div>
                      <div class="control-div" [formGroup]="ERROR">
                        <div class="control-label-container">
                          <label class="control-label"> Description </label>
                        </div>
                        <input class="control-input" [formControlName]="'description'"/>
                      </div>
                      <div class="control-div">
                        <ng-container *ngTemplateOutlet="next; context: { controlName: 'next', form: results.controls['ERROR']}">
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </clickatell-expansion-panel>
              </div>
            } @else {
              <div class="chat2pay-error">
                <div class="chat2pay-icon">
                  <img src='../../../../../../../../assets/svg/redesign/chat2pay-error-ico.svg'/>
                </div>
                <div class="chat2pay-config-message">
                  Chat 2 Pay needs to be configured in the Clickatell Portal first in order to use in Chat Flow
                </div>
                <a class="chat2pay-redirect" href="https://app.clickatell.com" target="_blank">
                  Go to Clickatell Portal
                </a>
              </div>
            }

            @if (loadingInProgress) {
              <div class="loading-block">
                <loading-icon></loading-icon>
              </div>
            }



            <ng-template #next let-controlName="controlName" let-form="form">
              <label class="point-to-label">
                Point To
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
              </label>
              @if (nodeFlowDetails) {
                <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                  [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                  [name]="controlName"
                  [form]="form"
                  [stepId]="nodeFlowDetails.stepId">
                ></next-selector>
              }
            </ng-template>
